import { render, staticRenderFns } from "./pdf-viewer.vue?vue&type=template&id=437b52fb&scoped=true&"
import script from "./pdf-viewer.vue?vue&type=script&lang=ts&"
export * from "./pdf-viewer.vue?vue&type=script&lang=ts&"
import style0 from "./pdf-viewer.vue?vue&type=style&index=0&id=437b52fb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "437b52fb",
  null
  
)

export default component.exports